module.exports = __webpack_public_path__ + "img/all-trades-iphone-03.757857db.png";